import { Vector3, Plane } from "three";
import { PanoImageQuadtree } from "../../infra3d";
import { GeoFrameCollection } from "./geoframecollection";
// TODO: Naming currently along the lines of stream.
export class PanoGeoFrameCollection extends GeoFrameCollection {
    constructor(scene, currentgeoframe, geoframearray) {
        super(scene, currentgeoframe, geoframearray);
        this.imagequadtree = null;
        //todo: define typing of sensors
        this.sensors = null;
        this.sensors = currentgeoframe.getMeasureInfo().sensors;
        function compare(a, b) {
            if (a.pos < b.pos)
                return -1;
            if (a.pos > b.pos)
                return 1;
            return 0;
        }
        this.sensors.sort(compare);
    }
    // TODO: Naming.
    load(frame = null) {
        if (this.onbuffering)
            this.onbuffering(true);
        let framenumber = frame ? this.frameIndex(frame) : 0;
        // Calculate Centroid for this stream:
        if (this.currentgeoframe != null)
            framenumber = this.currentgeoframe.getFramenumber();
        const numEntries = this.geoframearray.length;
        const mlt = 1.0 / numEntries;
        let easting_center = 0;
        let northing_center = 0;
        let height_center = 0;
        for (let i = 0; i < numEntries; i++) {
            easting_center = easting_center + mlt * this.geoframearray[i]["easting"];
            northing_center = northing_center + mlt * this.geoframearray[i]["northing"];
            height_center = height_center + mlt * this.geoframearray[i]["height"];
        }
        this.infrascene.engine.setCentroid([easting_center, northing_center, height_center]);
        //Create the QuadtreeNode
        const urls = [];
        for (const geoframe of this.geoframearray) {
            urls.push(geoframe.dataPath);
        }
        //instantiate a panorama node here...baseurlsPano, 612, 2048, 2448, 0, 2, 6, camInfo
        const im = this.measureinfo.imagemeta;
        this.imagequadtree = new PanoImageQuadtree(urls, im.tilesize, im.width, im.height, im.pixsize * 0.000001, im.minzoom, im.maxzoom, 1, this.sensors);
        this.scene.infrascene.panoramaMode = true;
        this.cachnotreadycbf = () => {
            this.cacheready = false;
            if (this.onbuffering)
                this.onbuffering(true);
        };
        this.imagequadtree.cacheNotReadyEvent = () => {
            this.cachnotreadycbf();
        };
        this.cachereadycbf = () => {
            this.cacheready = true;
            if (this.onbuffering)
                this.onbuffering(false);
        };
        this.imagequadtree.cacheReadyEvent = () => {
            this.cachereadycbf();
        };
        this.imagequadtree.visibleTilesNotReady = () => {
            this.alltilesready = false;
            if (this.onTileLoading)
                this.onTileLoading(true);
        };
        this.imagequadtree.visibleTilesReady = () => {
            this.alltilesready = true;
            if (this.onTileLoading)
                this.onTileLoading(false);
        };
        this.imagequadtree.framechangedcbf = (f) => {
            this._imageChanged();
        };
        this.infrascene.add(this.imagequadtree);
        this.imagequadtree.setActive(true);
        this.imagequadtree.onRotate = (lat, lng, fov) => {
            if (this.onRotate)
                this.onRotate(lat, lng, fov);
        };
        this.imagequadtree.frameskippedcbf = (newframenmbr) => {
            if (newframenmbr > this.geoframearray.length - 1)
                newframenmbr = this.geoframearray.length;
            if (newframenmbr < 0)
                newframenmbr = 0;
            this.currentgeoframe = this.geoframearray[newframenmbr];
        };
        //Set Camera Parameters
        this.infrascene.panoCamera.setOrientation([
            this.geoframearray[framenumber]["omega"],
            this.geoframearray[framenumber]["phi"],
            this.geoframearray[framenumber]["kappa"],
        ]);
        this.infrascene.panoCamera.setPosition([
            this.geoframearray[framenumber]["easting"],
            this.geoframearray[framenumber]["northing"],
            this.geoframearray[framenumber]["height"],
        ]);
        this.hasloaded = true;
        this.searchToFramenumber(framenumber);
        this.infrascene.render();
    }
    unload() {
        this.infrascene.remove(this.imagequadtree);
        this.imagequadtree.setActive(false);
        this.imagequadtree.destroy();
        this.imagequadtree = null;
        this.scene.infrascene.panoramaMode = false;
        if (this.lookatfc != null) {
            this.lookatfc.destroy();
            this.lookatfc = null;
        }
        this.hasloaded = false;
    }
    _imageChanged() {
        this.infrascene.panoCamera.setPosition([
            this.currentgeoframe.easting,
            this.currentgeoframe.northing,
            this.currentgeoframe.height,
        ]);
        this.infrascene.panoCamera.setOrientation([
            this.currentgeoframe.omega,
            this.currentgeoframe.phi,
            this.currentgeoframe.kappa,
        ]);
        this.infrascene.render();
        //determine inclination at current position for 2d-feature plane
        const idx = this.currentgeoframe ? this.frameIndex(this.currentgeoframe) : 0;
        let cidx = idx - 1;
        let nidx = idx + 1;
        if (idx + 1 == this.geoframearray.length) {
            cidx = idx - 1;
            nidx = idx;
        }
        if (idx == 0)
            cidx = idx;
        const p1 = new Vector3(this.geoframearray[cidx]["easting"], this.geoframearray[cidx]["northing"], this.geoframearray[cidx]["height"]);
        const p2 = new Vector3(this.geoframearray[nidx]["easting"], this.geoframearray[nidx]["northing"], this.geoframearray[nidx]["height"]);
        const v1 = p1.clone();
        v1.sub(p2);
        //define the plane
        const n = new Vector3(v1.y, -v1.x, 0); //orthognal of v1 in 2d space
        n.cross(v1);
        p1.z = p1.z - this.currentgeoframe.getMeasureInfo().height;
        const plane = new Plane().setFromNormalAndCoplanarPoint(n, p1);
        this.infrascene.setGroundPlane(plane);
        if (this.ongeoframechanged !== null)
            this.ongeoframechanged(this.currentgeoframe);
    }
    /**
     * Fits the image into the current canvas-size
     * @method fitToCanvas
     * @param {string} priority - not used in panostream
     */
    fitToCanvas(priority) {
        this.infrascene.panoCamera.setLatLon(this.measureinfo.tilt, this.measureinfo.orientation, 70);
    }
    /**
     * enable smear effect to hide callote borders
     */
    smearOn() {
        this.imagequadtree.smearOn();
    }
    /**
     * disable smear effect to hide callote borders
     */
    smearOff() {
        this.imagequadtree.smearOff();
    }
    setCacheRange(cacherange) {
        this.imagequadtree.setCacheRange(cacherange);
    }
    getLatLon() {
        return this.infrascene.panoCamera.getLatLon();
    }
    align_panoramic_view(current_geoframe, new_geoframe, reset = false) {
        const future_latlon = GeoFrameCollection.calcfuturelatlon(current_geoframe, new_geoframe, this.scene.panoramaresetthreshold, reset);
        this.infrascene.panoCamera.setInitLatLon(future_latlon[0], future_latlon[1]);
    }
}
//# sourceMappingURL=panogeoframecollection.js.map